// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewGroup_root__11x7-","hasRatio":"ViewGroup_hasRatio__2Pu-G","item":"ViewGroup_item__3OhcI","glue":"ViewGroup_glue__32HZ_"};